import React from "react";
import { MyProjects } from "./components/MyProjects/MyProjects";
import { AllProjects } from "./components/AllProjects/AllProjects";

export const ProjectsPage = ({ type }) => {
  if (type === "my") return <MyProjects />;
  if (type === "all") return <AllProjects />;
};
